(function () {
    'use strict';

    angular.module('checklistModule')
        .config(['$stateProvider', '$urlRouterProvider', routesConfig]);

    function routesConfig($stateProvider, $urlRouterProvider) {
        var internalPaths = window.paths;
        $stateProvider
            .state('checklistHome', {
                url: '/checklist-fe/home',
                templateUrl: internalPaths.FrontpageHome,
                controller: 'homeController',
                controllerAs: 'vm',
                reloadOnSearch: false,
                data: {
                    title: 'Checklist Home',
                    description: 'Checklist Home'
                }
            })
            .state('checklistCategories', {
                url: '/checklist-fe/categories?isHideTopbar',
                templateUrl: internalPaths.FrontpageHome,
                controller: 'homeController',
                controllerAs: 'vm',
                reloadOnSearch: false,
                data: {
                    title: 'Checklist categories',
                    description: 'Checklist categories'
                }
            })
            .state('completedchecklists', {
                url: '/checklist-fe/completedchecklists',
                templateUrl: internalPaths.FrontpageHome,
                controller: 'homeController',
                controllerAs: 'vm',
                reloadOnSearch: false,
                data: {
                    title: 'Completed checklist categories',
                    description: 'Completed checklist categories'
                }
            })
            .state('fillchecklistfromcategorymain', {
                url: '/checklist-fe/category/main',
                templateUrl: internalPaths.FrontpageHome,
                controller: 'homeController',
                controllerAs: 'vm',
                reloadOnSearch: false,
                data: {
                    title: 'Fill checklist categories',
                    description: 'Fill checklist categories'
                }
            })
            .state('adminsubcategory', {
                url: '/checklist-fe/adminsubcategory/:categoryId',
                templateUrl: internalPaths.FrontpageHome,
                controller: 'homeController',
                controllerAs: 'vm',
                reloadOnSearch: false,
                data: {
                    title: 'Admin sub categories',
                    description: 'Admin sub categories'
                }
            })
            .state('adminsubcategoryadd', {
                url: '/checklist-fe/adminsubcategory/add/:categoryId',
                templateUrl: internalPaths.FrontpageHome,
                controller: 'homeController',
                controllerAs: 'vm',
                reloadOnSearch: false,
                data: {
                    title: 'Add admin sub category',
                    description: 'Add admin sub category'
                }
            })
            .state('adminsubcategoryedit', {
                url: '/checklist-fe/adminsubcategory/edit/:categoryId',
                templateUrl: internalPaths.FrontpageHome,
                controller: 'homeController',
                controllerAs: 'vm',
                reloadOnSearch: false,
                data: {
                    title: 'Edit admin sub category',
                    description: 'Edit admin sub category'
                }
            })
            .state('admincategoryadd', {
                url: '/checklist-fe/category/add',
                templateUrl: internalPaths.FrontpageHome,
                controller: 'homeController',
                controllerAs: 'vm',
                reloadOnSearch: false,
                data: {
                    title: 'Add admin category',
                    description: 'Add admin category'
                }
            })
            .state('admincategoryedit', {
                url: '/checklist-fe/category/edit/:id',
                templateUrl: internalPaths.FrontpageHome,
                controller: 'homeController',
                controllerAs: 'vm',
                reloadOnSearch: false,
                data: {
                    title: 'Edit admin category',
                    description: 'Edit admin category'
                }
            })
            .state('checklistofsubcategory', {
                url: '/checklist-fe/list/:categoryId',
                templateUrl: internalPaths.FrontpageHome,
                controller: 'homeController',
                controllerAs: 'vm',
                reloadOnSearch: false,
                data: {
                    title: 'List Checklist',
                    description: 'List Checklist'
                }
            })
            .state('editchecklistdetail', {
                url: '/checklist-fe/tem/edit/:categoryId/:checklistId/:type',
                templateUrl: internalPaths.FrontpageHome,
                controller: 'homeController',
                controllerAs: 'vm',
                reloadOnSearch: false,
                data: {
                    title: 'Edit Checklist detail',
                    description: 'Edit Checklist detail'
                }
            })
            .state('editchecklistfield', {
                url: '/checklist-fe/tem/addeditfield/:categoryId/:checkListId/:type',
                templateUrl: internalPaths.FrontpageHome,
                controller: 'homeController',
                controllerAs: 'vm',
                reloadOnSearch: false,
                data: {
                    title: 'Edit Checklist field',
                    description: 'Edit Checklist field'
                }
            })
            .state('adminmaincategoryaccess', {
                url: '/checklist-fe/adminmaincategoryaccess',
                templateUrl: internalPaths.FrontpageHome,
                controller: 'homeController',
                controllerAs: 'vm',
                reloadOnSearch: false,
                data: {
                    title: 'Main categories Access',
                    description: 'Main categories Access'
                }
            })
            .state('editaccesscategory', {
                url: '/checklist-fe/editaccesscategory/:fromEntityId/:id/:fromType',
                templateUrl: internalPaths.FrontpageHome,
                controller: 'homeController',
                controllerAs: 'vm',
                reloadOnSearch: false,
                data: {
                    title: 'Edit categories Access',
                    description: 'Edit categories Access'
                }
            })
            .state('editaccesschecklist', {
                url: '/checklist-fe/editaccesschecklist/:fromEntityId/:id/:fromType',
                templateUrl: internalPaths.FrontpageHome,
                controller: 'homeController',
                controllerAs: 'vm',
                reloadOnSearch: false,
                data: {
                    title: 'Edit checklist Access',
                    description: 'Edit checklist Access'
                }
            })
            .state('editaccessmaincategory', {
                url: '/checklist-fe/editaccessmaincategory/:id',
                templateUrl: internalPaths.FrontpageHome,
                controller: 'homeController',
                controllerAs: 'vm',
                reloadOnSearch: false,
                data: {
                    title: 'Edit Access main category',
                    description: 'Edit Access main category'
                }
            })
            .state('editaccesscategorychecklist', {
                url: '/checklist-fe/editaccesscategorychecklist/:fromEntityId/:id/:type',
                templateUrl: internalPaths.FrontpageHome,
                controller: 'homeController',
                controllerAs: 'vm',
                reloadOnSearch: false,
                data: {
                    title: 'Edit Access category',
                    description: 'Edit Access category'
                }
            })
            .state('adminsubcategoryaccess', {
                url: '/checklist-fe/adminsubcategoryaccess/:id',
                templateUrl: internalPaths.FrontpageHome,
                controller: 'homeController',
                controllerAs: 'vm',
                reloadOnSearch: false,
                data: {
                    title: 'Admin sub category access',
                    description: 'Admin sub category access'
                }
            })
            .state('categorysubcategory', {
                url: '/checklist-fe/category/subcategory/:cateId',
                templateUrl: internalPaths.FrontpageHome,
                controller: 'homeController',
                controllerAs: 'vm',
                reloadOnSearch: false,
                data: {
                    title: 'Sub category',
                    description: 'Sub category'
                }
            })
            .state('checklistWidget', {
                url: '/checklist-fe/tem/viewlist/:cateId',
                templateUrl: internalPaths.FrontpageHome,
                controller: 'homeController',
                controllerAs: 'vm',
                reloadOnSearch: false,
                data: {
                    title: 'Checklist',
                    description: 'Checklist'
                }
            })
            .state('completedchecklistsdetail', {
                url: '/checklist-fe/completedchecklists/detail/:id',
                templateUrl: internalPaths.FrontpageHome,
                controller: 'homeController',
                controllerAs: 'vm',
                reloadOnSearch: false,
                data: {
                    title: 'Completed Checklist',
                    description: 'Completed Checklist'
                }
            })
            .state('implementChecklist', {
                url: '/checklist-fe/implement/add/:categoryId/:checklistId',
                templateUrl: internalPaths.FrontpageHome,
                controller: 'homeController',
                controllerAs: 'vm',
                reloadOnSearch: false,
                data: {
                    title: 'Implement Checklist',
                    description: 'Implement Checklist'
                }
            })
            .state('implementChecklistNoPermission', {
                url: '/checklist-fe/implement/fromemail/add/:categoryId/:checklistId',
                templateUrl: internalPaths.FrontpageHome,
                controller: 'homeController',
                controllerAs: 'vm',
                reloadOnSearch: false,
                data: {
                    title: 'Implement Checklist',
                    description: 'Implement Checklist'
                }
            })
            .state('editDraftChecklist', {
                url: '/checklist-fe/implement/edit/:categoryId/:checklistId/:implementId/:fieldId',
                templateUrl: internalPaths.FrontpageHome,
                controller: 'homeController',
                controllerAs: 'vm',
                reloadOnSearch: false,
                data: {
                    title: 'Edit Draft Checklist',
                    description: 'Edit Draft Checklist'
                }
            })
           ;
        $urlRouterProvider.otherwise('/');
    };
})();